import { filterInvalidChatItems, findFirstTextItem } from '@akin-home/chat';
import {
  postChatMessage,
  postPublicChatMessage,
  sendLabelledMessage,
} from './api';

export const chat_functions = {
  sendMessage: postChatMessage,
  sendPublicChatMessage: postPublicChatMessage,
  sendLabelledMessage,
  filterInvalidChatItems,
  findFirstTextItem,
};
